import EditSectionContent from './EditSectionContent';

export default EditSectionContent;
